"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var addressTools = _interopRequireWildcard(require("@simplybenefits/sb-address"));
var _FormModal = _interopRequireDefault(require("./FormModal"));
var _Loader = _interopRequireDefault(require("../Loader"));
var _BubbleSelectBlock = _interopRequireDefault(require("../BubbleSelectBlock"));
var _Text = _interopRequireDefault(require("../Text"));
var _TextInput = _interopRequireDefault(require("../TextFields/TextInput"));
var _PhoneInput = _interopRequireDefault(require("../TextFields/PhoneInput"));
var Services = _interopRequireWildcard(require("../../services"));
var _FormControl = _interopRequireDefault(require("@mui/material/FormControl"));
var _NumberInput = _interopRequireDefault(require("../TextFields/NumberInput"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
var localizationMaps = _interopRequireWildcard(require("../../localization/maps"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var MetaModal = /*#__PURE__*/function (_Component) {
  function MetaModal() {
    var _this;
    (0, _classCallCheck2["default"])(this, MetaModal);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, MetaModal, [].concat(args)), _this.state = {
      companyName: '',
      email: '',
      name: '',
      language: '',
      phone: '',
      authority: '',
      authorityEmail: '',
      suite: '',
      firstLine: '',
      city: '',
      province: '',
      postalCode: '',
      country: 'Canada',
      isASO: false,
      asoType: null,
      isAsoDental: null,
      isAsoHealth: null,
      asoAdminFeePercentage: 7,
      spendingAccountMarkup: 7,
      adjudicationFee: 10,
      allowVoluntaryBenefits: 1,
      allowOptionalBenefits: 0
    }, _this._onBlur = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(type) {
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this;
              _context.t1 = _defineProperty2["default"];
              _context.t2 = {};
              _context.t3 = "".concat(type, "Error");
              _context.next = 6;
              return Services.validateInput(type || "checkEmpty", _this.state[type]);
            case 6:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t1)(_context.t2, _context.t3, _context.t4);
              _context.t0.setState.call(_context.t0, _context.t5);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }(), _this._onAddressBlur = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(type) {
        var _this$state, firstLine, city, province, postalCode;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(type !== 'suite')) {
                _context2.next = 11;
                break;
              }
              _context2.t0 = _this;
              _context2.t1 = _defineProperty2["default"];
              _context2.t2 = {};
              _context2.t3 = "".concat(type, "Error");
              _context2.next = 7;
              return Services.validateInput(type, _this.state[type]);
            case 7:
              _context2.t4 = _context2.sent;
              _context2.t5 = (0, _context2.t1)(_context2.t2, _context2.t3, _context2.t4);
              _context2.next = 11;
              return _context2.t0.setState.call(_context2.t0, _context2.t5);
            case 11:
              _this$state = _this.state, firstLine = _this$state.firstLine, city = _this$state.city, province = _this$state.province, postalCode = _this$state.postalCode;
              if (!(firstLine && city && province && postalCode)) {
                _context2.next = 15;
                break;
              }
              _context2.next = 15;
              return addressTools.generateAddress(_this.state);
            case 15:
              return _context2.abrupt("return", null);
            case 16:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }(), _this._handleAddressChange = function (type, event) {
      _this.setState((0, _defineProperty2["default"])({}, type, event.target.value.replace(/,/g, '')));
    }, _this._handleInputChange = function (type, event, isValue) {
      _this.setState((0, _defineProperty2["default"])({}, type, isValue ? event : event.target.value));
    }, _this._validateForm = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var companyNameError, emailError, nameError, phoneError, authorityError, authorityEmailError, firstLineError, cityError, provinceError, postalCodeError, asoAdminFeePercentageError, spendingAccountMarkupError, adjudicationFeeError;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return Services.validateInput('companyName', _this.state.companyName);
          case 2:
            companyNameError = _context3.sent;
            _context3.next = 5;
            return Services.validateInput('email', _this.state.email);
          case 5:
            emailError = _context3.sent;
            _context3.next = 8;
            return Services.validateInput('name', _this.state.name);
          case 8:
            nameError = _context3.sent;
            _context3.next = 11;
            return Services.validateInput('phone', _this.state.phone);
          case 11:
            phoneError = _context3.sent;
            _context3.next = 14;
            return Services.validateInput('name', _this.state.name);
          case 14:
            authorityError = _context3.sent;
            _context3.next = 17;
            return Services.validateInput('authorityEmail', _this.state.authorityEmail);
          case 17:
            authorityEmailError = _context3.sent;
            _context3.next = 20;
            return Services.validateInput('firstLine', _this.state.firstLine);
          case 20:
            firstLineError = _context3.sent;
            _context3.next = 23;
            return Services.validateInput('city', _this.state.city);
          case 23:
            cityError = _context3.sent;
            _context3.next = 26;
            return Services.validateInput('province', _this.state.province);
          case 26:
            provinceError = _context3.sent;
            _context3.next = 29;
            return Services.validateInput('postalCode', _this.state.postalCode);
          case 29:
            postalCodeError = _context3.sent;
            _context3.next = 32;
            return Services.validateInput("checkEmpty", _this.state.asoAdminFeePercentage);
          case 32:
            asoAdminFeePercentageError = _context3.sent;
            _context3.next = 35;
            return Services.validateInput("checkEmpty", _this.state.spendingAccountMarkup);
          case 35:
            spendingAccountMarkupError = _context3.sent;
            _context3.next = 38;
            return Services.validateInput("checkEmpty", _this.state.adjudicationFee);
          case 38:
            adjudicationFeeError = _context3.sent;
            _this.setState({
              companyNameError: companyNameError,
              emailError: emailError,
              authorityError: authorityError,
              authorityEmailError: authorityEmailError,
              firstLineError: firstLineError,
              cityError: cityError,
              provinceError: provinceError,
              postalCodeError: postalCodeError,
              nameError: nameError,
              phoneError: phoneError,
              asoAdminFeePercentageError: asoAdminFeePercentageError,
              spendingAccountMarkupError: spendingAccountMarkupError,
              adjudicationFeeError: adjudicationFeeError
            });
            if (!(companyNameError || emailError || authorityError || authorityEmailError || firstLineError || cityError || provinceError || postalCodeError || nameError || phoneError || asoAdminFeePercentageError || spendingAccountMarkupError || adjudicationFeeError)) {
              _context3.next = 42;
              break;
            }
            return _context3.abrupt("return", false);
          case 42:
            return _context3.abrupt("return", true);
          case 43:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._edit = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      var isValid, generatedAddress, adminTemp, success;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this._validateForm();
          case 2:
            isValid = _context4.sent;
            if (isValid) {
              _context4.next = 5;
              break;
            }
            return _context4.abrupt("return", false);
          case 5:
            generatedAddress = addressTools.generateAddress({
              suite: _this.state.suite,
              firstLine: _this.state.firstLine,
              city: _this.state.city,
              province: localizationMaps.toEnglish('provinces', _this.state.province),
              postalCode: _this.state.postalCode,
              country: _this.state.country
            });
            adminTemp = _this.state.name.trim().split(' ');
            _context4.next = 9;
            return _this.props.edit({
              companyName: _this.state.companyName.trim(),
              companyAddress: generatedAddress.trim(),
              email: _this.state.email.trim(),
              firstname: adminTemp[0],
              lastname: adminTemp[1],
              language: localizationMaps.toEnglish("languages", _this.state.language) === "French" ? "fr" : "en",
              phone: _this.state.phone.trim(),
              authorityName: _this.state.authority.trim(),
              authorityEmail: _this.state.authorityEmail.trim(),
              isASO: Boolean(_this.state.isASO),
              asoType: _this.state.asoType,
              isAsoDental: Number(_this.state.isAsoDental),
              isAsoHealth: Number(_this.state.isAsoHealth),
              asoAdminFeePercentage: _this.state.asoAdminFeePercentage,
              spendingAccountMarkup: _this.state.spendingAccountMarkup,
              adjudicationFee: _this.state.adjudicationFee,
              allowVoluntaryBenefits: Boolean(_this.state.allowVoluntaryBenefits),
              allowOptionalBenefits: Boolean(_this.state.allowOptionalBenefits)
            });
          case 9:
            success = _context4.sent;
            if (success) {
              _this.props.hideModal();
            }
            return _context4.abrupt("return", null);
          case 12:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._create = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var isValid, generatedAddress, adminTemp, success;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return _this._validateForm();
          case 2:
            isValid = _context5.sent;
            if (isValid) {
              _context5.next = 5;
              break;
            }
            return _context5.abrupt("return", false);
          case 5:
            generatedAddress = addressTools.generateAddress({
              suite: _this.state.suite,
              firstLine: _this.state.firstLine,
              city: _this.state.city,
              province: localizationMaps.toEnglish('provinces', _this.state.province),
              postalCode: _this.state.postalCode,
              country: _this.state.country
            });
            adminTemp = _this.state.name.trim().split(' ');
            _context5.next = 9;
            return _this.props.create({
              companyName: _this.state.companyName.trim(),
              companyAddress: generatedAddress.trim(),
              email: _this.state.email.trim(),
              firstname: adminTemp[0],
              lastname: adminTemp[1],
              language: localizationMaps.toEnglish("languages", _this.state.language) === "French" ? "fr" : "en",
              phone: _this.state.phone.trim(),
              authorityName: _this.state.authority.trim(),
              authorityEmail: _this.state.authorityEmail.trim(),
              isASO: Boolean(_this.state.isASO),
              asoType: _this.state.asoType,
              isAsoDental: Number(_this.state.isAsoDental),
              isAsoHealth: Number(_this.state.isAsoHealth),
              asoAdminFeePercentage: _this.state.asoAdminFeePercentage,
              spendingAccountMarkup: _this.state.spendingAccountMarkup,
              adjudicationFee: _this.state.adjudicationFee,
              allowVoluntaryBenefits: Boolean(_this.state.allowVoluntaryBenefits),
              allowOptionalBenefits: Boolean(_this.state.allowOptionalBenefits)
            });
          case 9:
            success = _context5.sent;
            if (success) {
              _this.props.hideModal();
            }
            return _context5.abrupt("return", null);
          case 12:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    })), (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(MetaModal, _Component);
  return (0, _createClass2["default"])(MetaModal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.isEdit) {
        var address = addressTools.parseAddress(this.props.data.meta.address);
        this.setState({
          companyName: this.props.data.meta.company,
          email: this.props.data.meta.email,
          name: "".concat(this.props.data.meta.firstname, " ").concat(this.props.data.meta.lastname),
          language: this.props.data.meta.language === "fr" ? _i18n["default"].t(_tokens["default"].dropdowns.languages.french) : _i18n["default"].t(_tokens["default"].dropdowns.languages.english),
          phone: this.props.data.meta.phone,
          authority: this.props.data.meta.authority.name,
          authorityEmail: this.props.data.meta.authority.email,
          suite: address.suite || '',
          firstLine: address.firstLine || '',
          city: address.city || '',
          province: localizationMaps.fromEnglish("provinces", address.province) || '',
          postalCode: address.postalCode || '',
          country: this.props.data.meta.country,
          isASO: this.props.data.meta.aso.isASO,
          asoType: this.props.data.meta.aso.asoType || null,
          isAsoDental: this.props.data.meta.aso.isAsoDental,
          isAsoHealth: this.props.data.meta.aso.isAsoHealth,
          asoAdminFeePercentage: this.props.data.meta.aso.asoAdminFeePercentage || 7,
          spendingAccountMarkup: this.props.data.meta.spendingAccountMarkup || 7,
          adjudicationFee: this.props.data.meta.adjudicationFee || 10,
          allowVoluntaryBenefits: this.props.data.meta.allowVoluntaryBenefits,
          allowOptionalBenefits: this.props.data.meta.allowOptionalBenefits
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        showModal = _this$props.showModal,
        hideModal = _this$props.hideModal,
        isRevision = _this$props.isRevision;
      var styles = {
        row: {
          display: 'flex',
          flexDirection: 'row'
        },
        divider: {
          width: 40
        }
      };
      return /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: showModal,
        close: hideModal,
        title: this.props.isEdit ? _i18n["default"].t(_tokens["default"].titles.editDetails) : _i18n["default"].t(_tokens["default"].titles.createQuote),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: this.props.isEdit ? this._edit : this._create,
        whitelabel: this.props.whitelabel,
        customContainerStyle: {
          width: 500
        }
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.companyName),
        value: this.state.companyName,
        onBlur: function onBlur(e) {
          return _this2._onBlur('companyName', e);
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('companyName', value);
        },
        error: Boolean(this.state.companyNameError),
        helperText: this.state.companyNameError,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.contactEmail),
        onBlur: function onBlur(e) {
          return _this2._onBlur('email', e);
        },
        value: this.state.email,
        onChange: function onChange(value) {
          return _this2._handleInputChange('email', value);
        },
        error: Boolean(this.state.emailError),
        helperText: this.state.emailError,
        fullWidth: true,
        autofocus: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.adminName),
        value: this.state.name,
        onBlur: function onBlur(e) {
          return _this2._onBlur('name', e);
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('name', value);
        },
        error: Boolean(this.state.nameError),
        helperText: this.state.nameError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.quotes.adminLanguage),
        value: this.state.language,
        onBlur: function onBlur() {
          return _this2._onBlur('language');
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('language', value);
        },
        select: true,
        selectOptions: Services.selectFieldOptions.languageOptions(),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.streetAddress),
        value: this.state.firstLine,
        autocomplete: "shipping street-address",
        onBlur: function onBlur(e) {
          return _this2._onAddressBlur('firstLine', e);
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('firstLine', value);
        },
        error: Boolean(this.state.firstLineError),
        helperText: this.state.firstLineError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        value: this.state.suite,
        label: _i18n["default"].t(_tokens["default"].labels.account.suiteUnit),
        onBlur: function onBlur(e) {
          return _this2._onAddressBlur('suite', e);
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('suite', value);
        },
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.divider
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.cityTown),
        value: this.state.city,
        onBlur: function onBlur(e) {
          return _this2._onAddressBlur('city', e);
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('city', value);
        },
        error: Boolean(this.state.cityError),
        helperText: this.state.cityError,
        fullWidth: true
      })), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.row
      }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.province),
        value: this.state.province,
        onBlur: function onBlur(e) {
          return _this2._onAddressBlur('province', e);
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('province', value);
        },
        error: Boolean(this.state.provinceError),
        helperText: this.state.provinceError,
        select: true,
        selectOptions: Services.selectFieldOptions.provinceOptions(),
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: styles.divider
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.postalCode),
        value: this.state.postalCode,
        onBlur: function onBlur(e) {
          return _this2._onAddressBlur('postalCode', e);
        },
        onChange: function onChange(value) {
          return _this2._handleAddressChange('postalCode', value);
        },
        error: Boolean(this.state.postalCodeError),
        helperText: this.state.postalCodeError,
        fullWidth: true
      })), /*#__PURE__*/_react["default"].createElement(_PhoneInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.companyContactNumber),
        onBlur: function onBlur(e) {
          return _this2._onBlur('phone', e);
        },
        value: this.state.phone,
        onChange: function onChange(value) {
          return _this2._handleInputChange('phone', value);
        },
        error: Boolean(this.state.phoneError),
        helperText: this.state.phoneError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.signingAuthorityName),
        onBlur: function onBlur(e) {
          return _this2._onBlur('authority', e);
        },
        value: this.state.authority,
        onChange: function onChange(value) {
          return _this2._handleInputChange('authority', value);
        },
        error: Boolean(this.state.authorityError),
        helperText: this.state.authorityError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.signingAuthorityEmail),
        value: this.state.authorityEmail,
        onBlur: function onBlur(e) {
          return _this2._onBlur('authorityEmail', e);
        },
        onChange: function onChange(value) {
          return _this2._handleInputChange('authorityEmail', value);
        },
        error: Boolean(this.state.authorityEmailError),
        helperText: this.state.authorityEmailError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        margin: "20px 0 0px 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.includeOptionBenefits)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        tiny: true,
        light: true,
        margin: "5px 0 5px 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.includeOptionBenefitsMemo)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        disabled: true,
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.yes),
          selected: Boolean(this.state.allowOptionalBenefits) === true,
          field: 'allowOptionalBenefitsYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.no),
          selected: Boolean(this.state.allowOptionalBenefits) === false,
          field: 'allowOptionalBenefitsNo'
        },
        onBlur: function onBlur(e) {
          return _this2._onBlur('allowOptionalBenefits', e);
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(field) {
            return _regenerator["default"].wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(field === 'allowOptionalBenefitsYes')) {
                    _context6.next = 5;
                    break;
                  }
                  _context6.next = 3;
                  return _this2._handleInputChange('allowOptionalBenefits', true, true);
                case 3:
                  _context6.next = 7;
                  break;
                case 5:
                  _context6.next = 7;
                  return _this2._handleInputChange('allowOptionalBenefits', false, true);
                case 7:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          return function (_x3) {
            return _ref6.apply(this, arguments);
          };
        }())
      })), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        margin: "20px 0 5px 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.includeVoluntaryBenefits)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.yes),
          selected: Boolean(this.state.allowVoluntaryBenefits) === true,
          field: 'allowVoluntaryBenefitsYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.no),
          selected: Boolean(this.state.allowVoluntaryBenefits) === false,
          field: 'allowVoluntaryBenefitsNo'
        },
        onBlur: function onBlur(e) {
          return _this2._onBlur('allowVoluntaryBenefits', e);
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref7 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(field) {
            return _regenerator["default"].wrap(function _callee7$(_context7) {
              while (1) switch (_context7.prev = _context7.next) {
                case 0:
                  if (!(field === 'allowVoluntaryBenefitsYes')) {
                    _context7.next = 5;
                    break;
                  }
                  _context7.next = 3;
                  return _this2._handleInputChange('allowVoluntaryBenefits', true, true);
                case 3:
                  _context7.next = 7;
                  break;
                case 5:
                  _context7.next = 7;
                  return _this2._handleInputChange('allowVoluntaryBenefits', false, true);
                case 7:
                case "end":
                  return _context7.stop();
              }
            }, _callee7);
          }));
          return function (_x4) {
            return _ref7.apply(this, arguments);
          };
        }())
      })),
      // eslint-disable-next-line no-extra-boolean-cast
      !Boolean(this.props.advisorMeta) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isRevision && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.adjudicationFee),
        suffix: "%",
        value: this.state.adjudicationFee,
        onChange: function onChange(value) {
          return _this2._handleInputChange('adjudicationFee', value);
        },
        error: Boolean(this.state.adjudicationFeeError),
        helperText: this.state.adjudicationFeeError,
        fullWidth: true
      }), /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.spendingAccountMarkup),
        suffix: "%",
        value: this.state.spendingAccountMarkup,
        onChange: function onChange(value) {
          return _this2._handleInputChange('spendingAccountMarkup', value);
        },
        error: Boolean(this.state.spendingAccountMarkupError),
        helperText: this.state.spendingAccountMarkupError,
        fullWidth: true
      })), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true,
        margin: "20px 0 5px 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.asoHealthOrDental)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.yes),
          selected: Boolean(this.state.isASO) === true,
          field: 'isAsoYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.no),
          selected: Boolean(this.state.isASO) === false,
          field: 'isAsoNo'
        },
        onBlur: function onBlur(e) {
          return _this2._onBlur('isASO', e);
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref8 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(field) {
            return _regenerator["default"].wrap(function _callee8$(_context8) {
              while (1) switch (_context8.prev = _context8.next) {
                case 0:
                  if (!(field === 'isAsoYes')) {
                    _context8.next = 5;
                    break;
                  }
                  _context8.next = 3;
                  return _this2._handleInputChange('isASO', true, true);
                case 3:
                  _context8.next = 7;
                  break;
                case 5:
                  _context8.next = 7;
                  return _this2._handleInputChange('isASO', false, true);
                case 7:
                case "end":
                  return _context8.stop();
              }
            }, _callee8);
          }));
          return function (_x5) {
            return _ref8.apply(this, arguments);
          };
        }())
      })), this.state.isASO ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.asoType)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.account.budgeted),
          selected: this.state.asoType === 'Budgeted',
          field: 'Budgeted'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.account.inArrears),
          selected: this.state.asoType === 'Arrears',
          field: 'Arrears'
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref9 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(field) {
            return _regenerator["default"].wrap(function _callee9$(_context9) {
              while (1) switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this2._handleInputChange('asoType', field, true);
                case 2:
                case "end":
                  return _context9.stop();
              }
            }, _callee9);
          }));
          return function (_x6) {
            return _ref9.apply(this, arguments);
          };
        }())
      })), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.asoDental)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.yes),
          selected: this.state.isAsoDental === 1,
          field: 'isAsoDentalYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.no),
          selected: this.state.isAsoDental === 0,
          field: 'isAsoDentalNo'
        },
        onBlur: function onBlur(e) {
          return _this2._onBlur('isAsoDental', e);
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref10 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(field) {
            return _regenerator["default"].wrap(function _callee10$(_context10) {
              while (1) switch (_context10.prev = _context10.next) {
                case 0:
                  if (!(field === 'isAsoDentalYes')) {
                    _context10.next = 5;
                    break;
                  }
                  _context10.next = 3;
                  return _this2._handleInputChange('isAsoDental', 1, true);
                case 3:
                  _context10.next = 7;
                  break;
                case 5:
                  _context10.next = 7;
                  return _this2._handleInputChange('isAsoDental', 0, true);
                case 7:
                case "end":
                  return _context10.stop();
              }
            }, _callee10);
          }));
          return function (_x7) {
            return _ref10.apply(this, arguments);
          };
        }())
      })), /*#__PURE__*/_react["default"].createElement(_FormControl["default"], {
        component: "fieldset"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        small: true,
        bold: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.account.asoHealth)), /*#__PURE__*/_react["default"].createElement(_BubbleSelectBlock["default"], {
        first: {
          title: _i18n["default"].t(_tokens["default"].labels.yes),
          selected: this.state.isAsoHealth === 1,
          field: 'isAsoHealthYes'
        },
        second: {
          title: _i18n["default"].t(_tokens["default"].labels.no),
          selected: this.state.isAsoHealth === 0,
          field: 'isAsoHealthNo'
        },
        onBlur: function onBlur(e) {
          return _this2._onBlur('isAsoHealth', e);
        },
        handleChange: ( /*#__PURE__*/function () {
          var _ref11 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(field) {
            return _regenerator["default"].wrap(function _callee11$(_context11) {
              while (1) switch (_context11.prev = _context11.next) {
                case 0:
                  if (!(field === 'isAsoHealthYes')) {
                    _context11.next = 5;
                    break;
                  }
                  _context11.next = 3;
                  return _this2._handleInputChange('isAsoHealth', 1, true);
                case 3:
                  _context11.next = 7;
                  break;
                case 5:
                  _context11.next = 7;
                  return _this2._handleInputChange('isAsoHealth', 0, true);
                case 7:
                case "end":
                  return _context11.stop();
              }
            }, _callee11);
          }));
          return function (_x8) {
            return _ref11.apply(this, arguments);
          };
        }())
      })), isRevision && this.state.isASO && (this.state.isAsoHealth === 1 || this.state.isAsoDental === 1) && /*#__PURE__*/_react["default"].createElement(_NumberInput["default"], {
        label: _i18n["default"].t(_tokens["default"].labels.account.asoAdminFee),
        suffix: "%",
        value: this.state.asoAdminFeePercentage,
        onChange: function onChange(value) {
          return _this2._handleInputChange('asoAdminFeePercentage', value);
        },
        error: Boolean(this.state.asoAdminFeePercentageError),
        helperText: this.state.asoAdminFeePercentageError,
        fullWidth: true
      })) : null), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      }), /*#__PURE__*/_react["default"].createElement("span", {
        id: "createQuoteModal"
      }));
    }
  }]);
}(_react.Component);
var _default = exports["default"] = MetaModal;